export const privilegeArr = [
  [],
  [
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkhQUEFBQktSSFBURVlSVVhHNVRWVE43VDc3SEVGSSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2ODkyMTYwMjc5NTc0MjQ2ODN9?format=originalOFGHLERTH',
      text: 'See Who Likes You',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlMyS1RaU1JGVkVaT1A1RTNFNVBPSkNOWENZWUdNSiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU1NzAyNjUyMTIyNzgxNjQ4MTN9',
      text: "See who's viewed your profile",
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkNCWlpHWDNGVTNJVUNWWTVSWlpRU0RaUjZCWDVCSSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyMzQzNzQ0ODk3OTIxODA3NjkzfQ?format=originalOFGHLERTH',
      text: 'Unlimited Likes',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkRKTTNNT0Q0WU1ONjU1WlFEM0VIRUJYWFBEM1pYUCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMjI0NDg0Mjc5OTk5MDA0OTN9?format=originalOFGHLERTH',
      text: 'Free Crush x 2 per day',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkZHVEFMVlpONlBFN1I2M1VBSkdNTllEUkdCV0tPMyIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMTMwMjg5Njk2MTg1NTk3ODl9?format=originalOFGHLERTH',
      text: 'Read Receipts',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlMzQUJBVEpQTEw3RlJWSE43U1hWSFBaSE8zS1o3SCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMyNzU2NDUwNDMyODU0NTUxMjd9?format=originalOFGHLERTH',
      text: '1 Turbo per month',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IklEWjRJUlMzR1pKQUhZTUVJRkVXV0JNWVFPREZBRiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU1NzI1NDczMjg0Mzc4MDIzMTd9?format=originalOFGHLERTH',
      text: 'Restore Match',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjJZUEtISFhHUlBPR1MzUlNXUFFaT0dLVzZKUVVCNCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMyNzIzMTE4MzAyMjE1ODA2MjF9?format=originalOFGHLERTH',
      text: 'Unlock My Likes',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjZEN1RaNUFGRlJJQTRONE81MzJORVZGNDVJVFdYVSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyMzUxNjI4NDAwMTkzMjA0NTY3fQ?format=originalOFGHLERTH',
      text: 'Unlimited Rewind',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkRWQ1FLN1BWSE1NN1hDNkpXV1RGMzNBT1EzQ1BGUSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMyNzIxOTMzOTIyMDM0MjgxODF9?format=originalOFGHLERTH',
      text: 'Duet Premium Exclusive Icon',
    },
  ],
  [
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkdEVzM3WUQzTFZPTUdKRkQ3TUxMNkxVVFVQWkxKTiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxNDgzODEzOTM1NTU1MzQxMjN9?format=originalOFGHLERTH',
      text: 'People Nearby',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlhUVkNCNVlQWkpSNU9VQVlNVTdaWU9XMjZDVUhLRiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2ODk1MjAxMTIzNzYwNTAyMTl9?format=originalOFGHLERTH',
      text: 'Advanced Filters',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjZORVBHTldSU003NjZBTk1YSjNZVVdOSkxOTVBTRiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2ODk1MDQ5ODU5MDg2MDU0ODN9?format=originalOFGHLERTH',
      text: 'Praise x 3 per day',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlNIU1U0TUREQTNSU0g3SkdGSVFENEFHWlE1TE5OTCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE3MDcyMjg2MTk0MjgwNDkxOTV9?format=originalOFGHLERTH',
      text: 'Daily Picks',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik5XTUw1RVY1N05JUlA2WVRIR0VONUw1M01BU0lTNCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2OTI2MDkyNzE3NzA0Mjc2OTF9?format=originalOFGHLERTH',
      text: 'See Who Likes You',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlIyTVZRRFhGUUdFWFhEUFFHSjRWQU9IQzJJNk43NiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMjg0MTU0ODMxMzk0MzEyMTF9',
      text: "See who's viewed your profile",
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlZYU1FFTlY2S1YyUFRMVkc2UjZIVkFUT0VMUFRHQiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyOTEyMjE3NDQzNTgxMjYxMzU1fQ?format=originalOFGHLERTH',
      text: 'Unlimited Likes',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjU2U1VGWVFCU1VSMkVIRVQ3M1RaTEtBVVZDNjRNSyIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE3MTA2MzQ5NDEyMTI3Njk1Nzl9?format=originalOFGHLERTH',
      text: 'Free Crush x 2 per day',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkdQTVRMVVZITE1XWFkySjVXTFlIWTdYUDVVT1g3VSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyNDg4OTk4MjA0NTExNDQ5ODk5fQ?format=originalOFGHLERTH',
      text: 'Read Receipts',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkFSSTVXMlI2QjRSSURPWEpCR1Y3MjZJRTRJVktBWSIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE1NDczNTMwMDY0ODEzODc4MTl9?format=originalOFGHLERTH',
      text: '1 Turbo per month',
    },

    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlVCSUkzWUdJNlNTWVNGSVJFRDREVzNFNkIyU0ZQVyIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMjYyMjUwOTU5MzYwMjkyMjd9?format=originalOFGHLERTH',
      text: 'Restore Match',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkhJSUJKUElRRDVYSFBSUVhKSDZPTlNMNFlMWU9WNCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2OTAzNzA4NzIxODY1NDg1MjN9?format=originalOFGHLERTH',
      text: 'Unlock My Likes',
    },

    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlRYVEJJM1JOTEZPS1ZSWllKRktURlFTM1EzNE1aTiIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyNDcwOTc5MzUyMzM3NzkzODM1fQ?format=originalOFGHLERTH',
      text: 'Unlimited Rewind',
    },
    {
      url: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjY0UFpJVFJRM1NLTzZVWkE0SVAzRTNUTERCV0NRVyIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE3MTA2MTcyNzkyMzI1MjI1Mzl9?format=originalOFGHLERTH',
      text: 'Duet Premium Exclusive Icon',
    },
  ],
];

export const smallImgArr = [
  '',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IlQzNTVDMksyNTVHNkFWWkg3RFQ1V0JKVUxKNlk3VSIsInciOjI0LCJoIjoxNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU1OTA4NDMyNzEzNzg3MjAxNjJ9',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkdMTktSNEc0SzYyMzJSN1RMVEFGNTNYUU1RRFBBRCIsInciOjI0LCJoIjoxNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjg2ODY1NjE4ODMzMDQ1OTEzNn0',
];

export const fix0Arr = ['IDR', 'TWD', 'THB'];

export const monthObj: { [key: number]: number } = {
  0: 12,
  1: 3,
  2: 1,
};

// 服务端返回的category与当前tab的currentVip对应关系
export const vipObj: any = {
  vip: 0,
  seeWhoLikedMe: 1,
  supreme: 2,
  diamond: 3,
};

export const CategoryToCurVip: { [key: number]: string } = {
  0: 'vip',
  1: 'seeWhoLikedMe',
  2: 'supreme',
  3: 'diamond',
};

export const vipObj2: any = {
  0: 'vip',
  1: 'premium',
  2: 'supreme',
  3: 'diamond',
};

export const quantityToCurrentMonth: any = {
  12: 3,
  3: 2,
  1: 1,
  7: 0,
};

export const MonthToWeek = {
  1: 4,
  3: 13,
  12: 52,
};

export const WeeklyTopUpType = 'weeklyTopUp';

export const TabList = [
  { title: 'Premium', key: 1, name: 'premium' },
  { title: 'Supreme', key: 2, name: 'supreme' },
];

export const TimePeriods = [
  {
    value: 7,
    unit: 'days',
    title: 'Week',
    valueTitle: 1,
    saveText: '',
  },
  {
    value: 1,
    unit: 'months',
    title: 'Month',
    saveText: 'HOT DEAL',
  },
  {
    value: 3,
    unit: 'months',
    title: 'Months',
    saveText: 'POPULAR',
  },
  {
    value: 12,
    unit: 'months',
    title: 'Months',
    saveText: 'BEST VALUE',
  },
];

export const UnitWeek = '/w';
export const UnitMonth = '/m';
